import React, { useEffect, useRef } from "react";

// A faint glowing comet trail that follows the cursor across the page.
// Purely decorative; disabled on touch / coarse pointers.
export default function CursorTrail() {
  const wrapRef = useRef(null);
  const dotsRef = useRef([]);
  const target = useRef({ x: -100, y: -100 });
  const visible = useRef(false);

  useEffect(() => {
    const coarse = window.matchMedia("(pointer: coarse)").matches;
    if (coarse) return;

    const N = 7;
    const wrap = wrapRef.current;
    const dots = [];
    for (let i = 0; i < N; i++) {
      const d = document.createElement("span");
      d.className = "trail-dot";
      const scale = 1 - i / (N + 1);
      d.dataset.scale = scale;
      d.style.opacity = "0";
      wrap.appendChild(d);
      dots.push({ el: d, x: -100, y: -100, scale });
    }
    dotsRef.current = dots;

    const onMove = (e) => {
      target.current.x = e.clientX;
      target.current.y = e.clientY;
      visible.current = true;
    };
    const onLeaveDoc = () => { visible.current = false; };
    window.addEventListener("mousemove", onMove);
    document.addEventListener("mouseleave", onLeaveDoc);

    let raf;
    const tick = () => {
      let px = target.current.x;
      let py = target.current.y;
      dots.forEach((dot, i) => {
        dot.x += (px - dot.x) * 0.35;
        dot.y += (py - dot.y) * 0.35;
        px = dot.x;
        py = dot.y;
        const size = 26 * dot.scale + 6;
        dot.el.style.transform = `translate(${dot.x - size / 2}px, ${dot.y - size / 2}px)`;
        dot.el.style.width = `${size}px`;
        dot.el.style.height = `${size}px`;
        dot.el.style.opacity = visible.current ? `${0.12 * dot.scale + 0.03}` : "0";
      });
      raf = requestAnimationFrame(tick);
    };
    tick();

    return () => {
      window.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseleave", onLeaveDoc);
      cancelAnimationFrame(raf);
      dots.forEach((d) => d.el.remove());
    };
  }, []);

  return <div ref={wrapRef} className="cursor-trail" aria-hidden="true" />;
}
